module.exports = __webpack_public_path__ + "static/media/child.d305d9ab.svg";